/**
 * Store
 *
 * @author  Ritesh Shrivastav
 *
 */
import { createBrowserHistory } from 'history';
import rootReducer from './modules';
import thunk from 'redux-thunk';
import { createStore, applyMiddleware, compose, StoreEnhancer } from 'redux';
import { routerMiddleware } from 'connected-react-router';


export const history = createBrowserHistory();
const initialState = {};
const enhancers: StoreEnhancer[]= [];
const middleware = [
  thunk,
  routerMiddleware(history)
];

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = (window as any).devToolsExtension || (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension());
  }
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
)as StoreEnhancer

const store = createStore(
  rootReducer(history),
  initialState,
  composedEnhancers
);

// Get the type of our store variable
export type AppStore = typeof store
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore['getState']>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = AppStore['dispatch']

export default store;
